import React from "react";
import { useFormikContext, getIn } from "formik";
import { isNull } from "lodash";
// component
import { getDateFormat, maskDate } from "helper/dateFormat";
import { getDateFormatForDatePicket } from "helper/dateFormat";
import { getDateTimeFormatForDatePicket } from "helper/dateFormat";
import { getDateTimeFormat, maskDateTime } from "helper/dateFormat";
import { convertUTCToLocalDate } from "components/UTC/UtcConverter";
import { convertLocalToUTCDate } from "components/UTC/UtcConverter";
import { convertUTCToLocalDateTime } from "components/UTC/UtcConverter";
import { convertLocalToUTCDateTime } from "components/UTC/UtcConverter";
// direct import
import { DateTimePickerField } from "./view/DateTimePicker";

const DateTimeRangePicker = ({
  name,
  title,
  minDate,
  mandatory,
  checkValidation,
  showTimeSelect = false,
  ...rest
}) => {
  const dateMask = maskDate();
  const formik = useFormikContext();
  const dateTimeMask = maskDateTime();
  const { values, setFieldValue, errors, touched } = formik;

  const getError = getIn(errors, name);
  const getTouch = getIn(touched, name);
  const getFormValue = getIn(values, name);

  const selected = getFormValue
    ? showTimeSelect
      ? convertUTCToLocalDateTime(getFormValue)
      : convertUTCToLocalDate(getFormValue)
    : null;

  const handleChange = (date) => {
    isNull(date)
      ? setFieldValue(name, date)
      : showTimeSelect
      ? convertLocalToUTCDateTime(date, name, formik)
      : convertLocalToUTCDate(date, name, formik);
  };

  const alwaysAvailable = () => {
    const alwaysAvailableValue = getIn(values, "alwaysAvailable");

    if (!alwaysAvailableValue) {
      setFieldValue(name, null);
    }
    setFieldValue("alwaysAvailable", !alwaysAvailableValue);
  };

  return (
    <DateTimePickerField
      mandatory={mandatory}
      title={title}
      name={name}
      checkValidation={checkValidation}
      selected={selected}
      onChange={handleChange}
      minDate={minDate}
      showTimeSelect={showTimeSelect}
      dateFormat={
        showTimeSelect
          ? getDateTimeFormatForDatePicket()
          : getDateFormatForDatePicket()
      }
      placeholderText={showTimeSelect ? getDateTimeFormat() : getDateFormat()}
      mask={showTimeSelect ? dateTimeMask : dateMask}
      formik={formik}
      checkAvailableHandler={alwaysAvailable}
      error={getError}
      getTouch={getTouch}
      {...rest}
    />
  );
};

export default DateTimeRangePicker;
